
(function () {
  'use strict';

  if (customElements.get('blog-editorial-slider')) return;

  class BlogEditorialSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');

      if (!this.track) return;

      this.onScroll = () => this.updateArrows();
      this.onResize = () => this.updateArrows();

      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);

      this.track.addEventListener('scroll', this.onScroll, {
        passive: true
      });

      window.addEventListener('resize', this.onResize);

      requestAnimationFrame(() => this.updateArrows());
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);

      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    getStep() {
      const slide = this.track.querySelector('.blog-editorial-slide');

      if (!slide) return this.track.clientWidth;

      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return slide.getBoundingClientRect().width + gap;
    }

    move(direction) {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.track.scrollBy({
        left: this.getStep() * direction,
        behavior: reduceMotion ? 'instant' : 'smooth'
      });
    }

    updateArrows() {
      const track = this.track;
      if (!track) return;

      const maxScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= maxScroll - 2;
      const hasOverflow = maxScroll > 2;

      if (this.prev) {
        this.prev.hidden = !hasOverflow || atStart;
      }

      if (this.next) {
        this.next.hidden = !hasOverflow || atEnd;
      }
    }
  }

  customElements.define('blog-editorial-slider', BlogEditorialSlider);
})();
